import React from "react"

function TpaModal({ medicalType, isOpen, setIsOpen, handleSkip }) {
    if (!isOpen) {
      return null
    }
  
    return (
      <>
        <div className="tpa-modal-overlay"></div>
        <div className="tpa-modal-container">
          <button
            className="tpa-modal-close-btn"
            onClick={() => setIsOpen(false)}
          >
            x
          </button>
          <p className="tpa-modal-text">
            Please expect a call from our TPA shortly to schedule appointment for
            your {medicalType?.toLowerCase()}.
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "35px",
            }}
          >
            <div className="previous-btn cen" aria-hidden={true} onClick={() => handleSkip()}>
              <a>
                <button
                  type="submit"
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    color: "#fff",
                  }}
                >
                  Ok
                </button>
              </a>
            </div>
          </div>
        </div>
      </>
    )
}

export default TpaModal